import {
  DraggablePanelBody,
  DraggablePanelFooter,
  DraggablePanelHeader,
  DraggablePanelRoot,
} from '@components/ui/draggable/DraggablePanel';

export const DraggablePanel = {
  Root: DraggablePanelRoot,
  Header: DraggablePanelHeader,
  Body: DraggablePanelBody,
  Footer: DraggablePanelFooter,
};
